import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  getSelectedSecuritySurveillance,
  getSelectedSecuritySurveillancePermission
} from '@capital-access/common/security';
import { TARGETING_COMMON_KEY } from '../../constants';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'ca-surveillance-popover',
  templateUrl: './surveillance-popover.component.html',
  standalone: false
})
export class SurveillancePopoverComponent {
  localizationKey: string = TARGETING_COMMON_KEY;

  isSurveillanceSecurity$ = this.store.select(getSelectedSecuritySurveillancePermission);
  isSurveillanceToggledSecurity$ = this.store.select(getSelectedSecuritySurveillance);

  @Input() isFundsInfo = false;
  @Input() toggleSensitive = false;
  @Input() iconSize: 'sm' | 'xs' = 'xs';

  constructor(private store: Store) {}

  get showPopover$() {
    return combineLatest([this.isSurveillanceToggledSecurity$, this.isSurveillanceSecurity$]).pipe(
      map(([isSurveillanceToggled, isSurveillance]) => (this.toggleSensitive ? isSurveillanceToggled : isSurveillance))
    );
  }
}
